import { createAction, props } from '@ngrx/store';
import { ScimApiKey } from '../../models/domain';

export const ScimActions = {
  Load: createAction('[SCIM] load'),
  Loaded: createAction('[SCIM] loaded', props<{ apiKeys: ScimApiKey[] }>()),
  Generate: createAction('[SCIM] generate', props<{ keyName: string }>()),
  Generated: createAction('[SCIM] generated', props<{ apiKey: ScimApiKey }>()),
  Revoke: createAction('[SCIM] revoke', props<{ apiKeyId: string }>()),
  Revoked: createAction('[SCIM] revoked', props<{ apiKeyId: string }>()),
};
